import { Column } from '@ant-design/charts';
import _ from "underscore";

var data = [
    {
      date: 'March 30, 2024',
      value: 20,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 2, 2024',
      value: 15,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 5, 2024',
      value: 20,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 8, 2024',
      value: 30,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 11, 2024',
      value: 25,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 14, 2024',
      value: 5,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 17, 2024',
      value: 12,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 20, 2024',
      value: 28,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 23, 2024',
      value: 17,
      type: '超過六個字的範例',
    },
    {
      date: 'Apr 26, 2024',
      value: 2,
      type: '超過六個字的範例',
    }
]

  

const ChartReporting = (props) => {

    var config = {
        data: data,
        isStack: true,
          autoFit: true,
          appendPadding: [17, 0, 0, 0],
          xField: 'date',
          yField: 'value',
          seriesField: 'type',
        //   legend: {
        //     position: 'right-top',
        //     offsetY: 17,
        //     itemName: {
        //       formatter: (text) => {
        //         const oldLabel = text;
        //         const labelLength = oldLabel.length;
        //         let newLabel = '';
        //         if (labelLength > 6) {
        //           const firstStr = oldLabel.substr(0, 6);
        //           const lastStr = oldLabel.substr(6);
        //           newLabel = `${firstStr}\n${lastStr}`;
        //         } else {
        //           newLabel = oldLabel;
        //         }
        //         return newLabel;
        //       },
        //     },
        //   },
          xAxis: {
            //  
            line: {
              style: {
                stroke: 'black',
              },
            },
            tickLine: {
              style: {
                stroke: 'black',
              },
            },
            label: {
              style: {
                fill: 'black',
              },
            },
          },
          yAxis: {
            line: {
              style: {
                lineWidth: 2,
              },
            },
            label: {
              style: {
                fill: 'black',
              },
              offset: 15,
              formatter: (text) => {
                const label = _.round(_.divide(text, 1000), 2);
    
                return label;
              },
            },
          },
          tooltip: {
            showTitle: false,
            formatter: (datum) => {
              return {
                name: `${datum.type}`,
                value: `${datum.value.toLocaleString()}`,
              };
            },
          },
      };

    return (
        <div className='reporting-chart'>
            <Column {...config} />
        </div>
    )
}

export default ChartReporting